import React from 'react'
import { ConfirmDialog } from '@sendoutcards/quantum-design-ui'
import { useMarketingContent } from 'src/react_query'

const WhyMyPhoneNumberDialog = (props: {
  isCreateOrLogin: boolean
  onAccept: () => void
  onClose: () => void
}) => {
  const { isCreateOrLogin, onAccept, onClose } = props
  const { data: marketingContent } = useMarketingContent({ suspense: true })

  if (!marketingContent) {
    throw Error("Couldn't get Marketing Content")
  }

  const { whyMyPhoneNumberMessage, whyMyPhoneNumberValidateMessage } =
    marketingContent
  // Both share the same title
  const title = whyMyPhoneNumberMessage.title
  const content = isCreateOrLogin
    ? whyMyPhoneNumberMessage.content
    : whyMyPhoneNumberValidateMessage.content
  return (
    <ConfirmDialog
      isOpen={true}
      title={title}
      description={content}
      accept={{ title: 'Got it', onClick: () => onAccept() }}
      primaryAction={'accept'}
      onClose={() => onClose()}
      data-mktcontent="whyMyPhoneNumberMessage"
      maxWidth={'80%'}
    />
  )
}

export default WhyMyPhoneNumberDialog
